var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('kendo-multiselect',{ref:'stagesMultiSelect',attrs:{"data-source":_vm.stageDataSource,"data-value-field":'StageIdentity',"data-text-field":'StageName',"placeholder":'No fields selected...'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }